// Order Type IDs stored in localStorage
export enum OrderTypeIds {
    NIGHT_SHIFT = 'night-shift',
    MEETING_ROOM = 'meeting-room'
}

// Legacy venue name patterns (deprecated - use OrderTypeIds instead)
export enum VenueTypes {
    NIGHT_SHIFT = 'nachtschicht',
    MEETING_ROOM = 'meetingraum'
}
